import { observer } from 'mobx-react';
import { LicenseFamily } from '../../../../../../Organization/Types';
import { T } from '../../../../../../Translations';

interface Props {
  licenseFamily: LicenseFamily;
}

function LimaHeaders({ licenseFamily }: Props) {
  switch (licenseFamily) {
    case 'lima':
      return (
        <>
          <th className="hidden px-3 py-3.5 text-left text-sm font-semibold text-gray-900 lg:table-cell">
            <T kind="Licenses" />
          </th>
          <th className="hidden px-3 py-3.5 text-left text-sm font-semibold text-gray-900 lg:table-cell">
            <T kind="License Status" />
          </th>
        </>
      );
    case 'classic':
      return <></>;
  }
}

export default observer(LimaHeaders);
